
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SubjectCode } from '@/const/SubjectCode'

/**
 * 教科表示チップ
 */
@Component
export default class SubjectTip extends Vue {
  /** 教科コード */
  @Prop()
  private subjectCode!: string

  /**
   * 教科コードからラベルを引当てて返す
   *
   * @returns 教科のラベル
   */
  private get label(): string {
    const label = SubjectCode.findByCode(this.subjectCode)?.label
    return label || ''
  }

  /**
   * css定義用メソッド
   *
   * @returns css指定
   */
  private setStyle(): { [key: string]: string } {
    const color = SubjectCode.findByCode(this.subjectCode)?.color
    return {
      '--color-subject__background': `var(${color})`,
    }
  }
}
